import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchExternalClientDetails, checkIsWBSEValid } from "../../../redux/fui/index";
import { checkRootExisted } from "../../../redux/fui";
import {
    StyledTooltip, StyledRadioGroup,
    TopRadioWrapper,
    StyledFormControl,
    ConfigurationFormLabel,
} from "../FuiStyles";
import { longTextEndDate, rootExistedHint, rootWrongFormatHint } from "../Constants/LongText";
import { useDebounce } from "../../../helper/customizedHooks";
import { DateTextFieldCommonComponent, DateTextFieldCommonComponentv2 } from "../DateTextFieldCommonComponent/DateTextFieldCommonComponent";
import * as FormField from "./IndividualFormFields";
import * as PlatformFormField from "./IndividualFormFields";
import { checkServiceNowTicket, checkRITM, checkOpportunityID, checkWBSECode, checkPOCname, createMaxDate } from "./CommonFunctions";
import GeneralForm from "./GeneralForm";
import * as fuiRedux from "../../../redux/fui/index";
import { Grid, FormControlLabel, Radio, DialogActions, FormLabel, Checkbox, FormGroup } from "@material-ui/core";
import priceConfig from "./pricetotierMapping";
import { CommonDialog, CommonDialogV2 } from "../../common/CommonComponents/Dialog";
import { AcceptButton2 } from "../../common/CommonComponents/Buttons";
import ValidationDialog from './ValidationDialog';
import useFormValidationWithBorders from './useFormValidationWithBorders';

/**
 * Turing Form
 * @author shilpa.adikeshava
 * @version 2.0
 * @see Used in component: PlatformLicenseStepper
 */

const NoTouch = ({
    values, // the value would be changed by user's input
    updateGAForm, //the function to update DPForm values which is from redux
    createdBy, // user's EID
    checkDomainAvaliable, // the function that check whether DomainContextRoot exist or not from redux
    isRootExist, // the value that show whether DomainContextRoot exist or not from redux
    setIsAllValid, // the function to check whether all validations are satisfieds
    selectedEnvironment,
    minDate,
    maxDate,
    isServiceEndDateInvalid,
    getSelectedEnvironment,
    getServiceEndDate,
    getNotesValue,
    notesValidations,
    configurationType,
    classes,
    history,
    email,
    idToken,
    isExternalClientLoading,
    externalClientData,
    externalClientError,
    fetchExternalClientDetails,
    isLoading,
    formClickSubmit,
    checkIsWBSEValid,
    isWBSEValid, // this value shows whether the WBSE is valid or not from redux
}) => {

    // open the dialog when user choose Yes in GDPR
    const config = configurationType === "quick";
    //check whether RITM is valid
    const [isRITMValid, setIsRITMValid] = useState(true);
    const [ritmAPIValidation, setRITMAPIValidation] = useState(null);

    //check whether OpportunityID is valid
    const [isOpportunityIDValid, setIsOpportunityIDValid] = useState(true);
    const [opportunityAPIValidation, setOpportunityAPIValidation] = useState(null);
    const [ttpword, setTtpword] = useState({
        'ADO': false,
        'JIRA': false,
    });
    // check whether WBSECode and MonthlyTicketVolume are valid
    const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);
    const [isProjectNameValid, setIsProjectNameValid] = useState(true);

    const [isDialogFlowDevToken, setIsDialogFlowDevToken] = useState(false);

    const [isDialogFlowClientToken, setIsDialogFlowClientToken] = useState(false);
    //   const [isUsersFieldValid, setUsersField] = useState(false);
    const isGDPR = values.GDPR === "yes";
    const isOpenAI = values.OpenAI === "True";
    // const isMultisource = values.EnableMultisource == true; 
    const isAAAMTermsConditions = values.AAAMTermsConditions === "yes";
    const isDialogFlow = values.DialogFlow === "enabled";
    const isDedicated = values.InstanceType === history.location.state.InstanceType;
    //   const isPaymentRate = values.PaymentRate === "payasyougo";
    const [isNoteVisible, setNoteVisible] = useState(true);

    const instanceType = "Container";
    const Tier = instanceType && instanceType == "Container" ? values.Tier === '' ? 'gold' : values.Tier : values.Tier

    const [sapContractCodeLength, setSapContractCodeLength] = useState("0");
    const [domainContextRoot, setDomainContextRoot] = useState("[__]");
    const [regionCode, setRegionCode] = useState("[__]");
    const [errorADGroup, setErrorADGroup] = useState(false);
    const [errorSADGroup, setErrorSADGroup] = useState(false);
    //check if Admin Distribution Group & Super Admin Distribution Group same
    const [isADSADUnique, setIsADSADUnique] = useState(false);
    const [customURL, setCustomURL] = useState("https://[__].mywizard-aiops.accenture.com/[__]");
    const [isTeamNameSelected, setIsTeamNameSelected] = useState(true);
    const [env, setEnv] = useState("");
    const [isPocvalid, setPocvalid] = useState(true);
    const [isPlanInputValid, setIsPlanInputValid] = useState(false);
    const assets = `Accenture.GenWizardAgent.ProcessToDesign.WebAPI.service,Accenture.GenwizardCore.WebAPI.service,Accenture.GenWizard.Agent.BusinessAnalyzer.WebAPI.service,Accenture.GenWizard.Agent.ChangeAnalyzer.WebAPI.service,Accenture.GenWizard.Agent.SoftwareEngineering4.0.WebAPI,Accenture.GenWizard.Agent.DataEngineering.WebAPI.service,Accenture.GenWizard.Agent.TestAnalyzer.WebAPI,Accenture.GenWizard.Agent.DataEngineeringPython,Accenture.GenWizard.Agent.DataModernization.Python,Accenture.GenWizard.VectorVault.WebAPI.Python.service,Accenture.GenWizard.MarketPlace.CIABAAmbiguity.WebAPI.Python,Accenture.GenWizard.SAPAgent.WebAPI.Python,Accenture.GenWizard.Agent.SoftwareEngineering.WebAPI.Python,Accenture.GenWizard.Agent.SAPAdvisory.Python,Accenture.GenWizard.MessageBroker.WinService.service,Accenture.GenWizard.MCP.Dataai.Python,Accenture.GenWizard.DiagnosticsMCPService.WebAPI.Python,Accenture.GenWizard.SAPAssessment.WebAPI.Python`;
    const assetsList = assets
        .split(",")
        .map(item => item.trim());
    const sortAssetsList = assetsList.sort();
    const [selectedAsset, setSelectedAsset] = useState([]);
    const [isChecked, setIsChecked] = useState(true);

    // Use enhanced validation hook with red borders and dialog management
    const { validationErrors, showValidationDialog, closeDialog, handleValidationResult } = useFormValidationWithBorders(values, isWBSEValid, selectedEnvironment);

    const handleContractAvailabilityChange = (event) => {
        const value = event.target.value;
        setIsChecked(value === "yes");
        // updateGAForm("IsContractIdAvailable", value);
        if (value === "no") {
            updateGAForm("IsContractIdAvailable", "no");
            updateGAForm("SAPContractID", "0000000000");
            updateGAForm("EndToEndUId", "");
            updateGAForm("ContractAvailabilityDate", createMaxDate(14));
            setSapContractCodeLength(10)
            setPocvalid(false);
        } else {
            setPocvalid(true);
            updateGAForm("SAPContractID", "")
            updateGAForm("ClientName", "")
            updateGAForm("EndToEndUId", "")
            setSapContractCodeLength(0)
        }
    };


    useEffect(() => {
        if (config) {
            setDomainContextRoot("[__]");
            setRegionCode("[__]");
        }
    }, [config]);
    if (config) {
        // updateGAForm("ClientName", "")
        updateGAForm("EndToEndUId", "")
        updateGAForm("Company", "")
        updateGAForm("AvanadeCountry", "")
        updateGAForm("AccentureCountry", "")
        updateGAForm("InstanceType", "Container")
        updateGAForm("Tier", Tier)
        updateGAForm("ContractAvailabilityDate", "")
        // updateGAForm("CAMPortalEnvironment", process.env.REACT_APP_CAMENVPORTAL)
    }

    if (!config) {
        if (externalClientData.length > 0) {
            updateGAForm("ClientName", externalClientData[0])
            updateGAForm("EndToEndUId", externalClientData[1])
            updateGAForm("InstanceType", "Container")
            updateGAForm("Tier", Tier)
            if (externalClientData[2] !== undefined)
                updateGAForm("Company", externalClientData[2])
            if (externalClientData[3] !== undefined)
                updateGAForm("AvanadeCountry", externalClientData[3])
            if (externalClientData[4] !== undefined)
                updateGAForm("AccentureCountry", externalClientData[4])
            if (isChecked && externalClientData[5] !== undefined)
                updateGAForm("GDPR", externalClientData[5] ? "yes" : "no")
            updateGAForm("ContractAvailabilityDate", "")
            updateGAForm("IsContractIdAvailable", "yes")
            // updateGAForm("CAMPortalEnvironment", process.env.REACT_APP_CAMENVPORTAL)
        } else {
            updateGAForm("InstanceType", "Container")
            updateGAForm("Tier", Tier)
            // updateGAForm("CAMPortalEnvironment", process.env.REACT_APP_CAMENVPORTAL)
        }
    }

    // Since we're now validating only on final submit, always allow the form to be "valid"
    // for navigation purposes. Final validation happens in validateInputFields('submit')
    setIsAllValid(true);

    // user can only input lower case letter and numbers in DomainContextRoot
    const handleChangeRoot = (event, fieldName) => {
        const re = /^[a-z0-9]*$/;
        const value = event.target.value;
        re.test(value) && updateGAForm(fieldName, value);
        setDomainContextRoot(value)
    };
    const handleChangeRootSuggestions = (event, value, fieldName) => {
        const re = /^[a-z0-9]*$/;
        // const value = event.target.value;
        re.test(value) && updateGAForm(fieldName, value);
        setDomainContextRoot(value)
    };

    // get user's input
    const handleChange = (event, fieldName) => {
        if (fieldName === "TentativeServiceEndDate" || fieldName === "ContractAvailabilityDate") {
            updateGAForm(fieldName, event);
            getServiceEndDate(event);
        } else if (fieldName === "TeamName") {
            if (event !== undefined || event !== null) {
                updateGAForm(fieldName, event);
                setIsTeamNameSelected(true);
                if (values.TeamName !== "Others") {
                    updateGAForm("TeamNameOthers", "")
                }
            } else {
                setIsTeamNameSelected(false);
            }
        } else {
            const { value } = event.target;
            event.preventDefault();
            updateGAForm(fieldName, value);
            if (fieldName === "WBSEcode") {
                // setIsWBSECodeValid(checkWBSECode(value));
                const isWBSEFormatValid = checkWBSECode(value);
                if (isWBSEFormatValid) {
                    checkIsWBSEValid(value)
                }
            }
            if (fieldName === "Pocdetails") {
                setPocvalid(checkPOCname(value));
            }
            if (fieldName === "Pocdetails") {
                setPocvalid(checkPOCname(value));
            }
            if (fieldName === "ProjectName") {
                if (value.length > 32 || value.length < 3) {
                    setIsProjectNameValid(false)
                } else {
                    setIsProjectNameValid(true)
                }
            }
            if (fieldName === "RITM") {
                setIsRITMValid(checkRITM(value));
            }
            if (fieldName === "OpportunityID") {
                setIsOpportunityIDValid(checkOpportunityID(value));
            }
            if (fieldName === "DialogFlowDevToken") {
                if (value.length > 0) {
                    setIsDialogFlowDevToken(true);
                } else {
                    setIsDialogFlowDevToken(false);
                }
            }
            if (fieldName === "DialogFlowClientToken") {
                if (value.length > 0) {
                    setIsDialogFlowClientToken(true);
                } else {
                    setIsDialogFlowClientToken(false);
                }
            }
            // if (fieldName === "Environment") {
            //   getSelectedEnvironment(value);
            // }

            // if (fieldName === "InstanceType") {
            //     if (value == "Dedicated") {
            //     } else {
            //         updateGAForm("CAMPortalEnvironment", "UAT");
            //     }
            // }
            if (fieldName === "TentativeServiceEndDate") {
                getServiceEndDate(value);
            }
            if (fieldName === "AdminDistributionGroup") {
                if (value == values.SuperAdminDistributionGroup) {
                    setIsADSADUnique(true)
                } else {
                    setIsADSADUnique(false)
                }
                if (value.includes(",") || value.includes(";") || value.includes(" ") || value.includes("@")) {
                    setErrorADGroup(true)
                } else {
                    setErrorADGroup(false)
                }
            }
            if (fieldName === "SuperAdminDistributionGroup") {
                if (value == values.AdminDistributionGroup) {
                    setIsADSADUnique(true)
                } else {
                    setIsADSADUnique(false)
                }
                if (value.includes(",") || value.includes(";") || value.includes(" ") || value.includes("@")) {
                    setErrorSADGroup(true)
                } else {
                    setErrorSADGroup(false)
                }
            }
            if (fieldName === "RequestNotes") {
                if (value.length > 0 && value.length < 247) {
                    getNotesValue({ emptyString: false, maxLength: false });
                } else if (value.length === 0) {
                    getNotesValue({ emptyString: true, maxLength: false });
                } else if (value.length > 246) {
                    getNotesValue({ emptyString: false, maxLength: true });
                }
            }
            if (fieldName === "SAPContractID") {
                let sapLength = value.length
                setSapContractCodeLength(sapLength)
                if (sapLength == 10) {
                    fetchExternalClientDetails(value)
                }
            }
            if (fieldName === "Genwizard_Core") {
                let appcore = values.Genwizard_Core;
                // const pair = ['CUI', 'IAM'];
                const appName = event.target.name;
                if (appcore.includes(appName))
                    appcore = appcore.filter(item => item !== appName);
                else
                    appcore.push(appName)

                // if (pair.includes(event.target.name)) {
                //     if (!event.target.checked) {
                //         appcore = appcore.filter(item => !pair.includes(item));
                //     } else {
                //         appcore = [...new Set([...appcore, ...pair])];
                //     }
                // }

                // if (pair.includes(event.target.name)) {
                //     if (!event.target.checked) {
                //         appcore = appcore.filter(item => item !== 'KM');
                //     }
                // }

                if (appcore.includes('AD')) {
                    // ['IAM', 'KM', 'CUI'].map(core => {
                    ['KM', 'CUI'].map(core => {
                        if (!appcore.includes(core))
                            appcore.push(core)
                    })
                }


                if (appcore.includes('UTKM')) {
                    // ['IAM', 'KM', 'CUI'].map(core => {
                    ['KM', 'CUI'].map(core => {
                        if (!appcore.includes(core))
                            appcore.push(core)
                    })
                }

                // if (event.target.name === 'AD' && event.target.checked === false) {
                if (['AD', 'UTKM'].includes(event.target.name) && event.target.checked === false) {
                    if (!appcore.includes('AD') && !appcore.includes('UTKM')) {
                        appcore = []
                        updateGAForm("Genwizard_Agent_Module", []);
                    } else if (appcore.includes('UTKM')) {
                        updateGAForm("Genwizard_Agent_Module", ['Config-Agent']);
                    }
                } else {
                    if (['AD', 'UTKM'].includes(event.target.name)) {
                        let agent = [...values.Genwizard_Agent_Module];
                        if (!agent.includes('Config-Agent')) {
                            updateGAForm("Genwizard_Agent_Module", ['Config-Agent']);
                        }
                    }
                }
                updateGAForm(fieldName, appcore);
            }
            if (fieldName === 'Genwizard_Agent_Module') {
                let agent = [...values.Genwizard_Agent_Module];
                if (event.target.name === 'CIA') {
                    if (event.target.checked === false) {
                        agent = agent.filter(item => item !== 'CIA');
                        updateGAForm('modelname', '');
                    } else {
                        agent.push('CIA')
                    }
                    updateGAForm(fieldName, agent);
                } else {
                    if (agent.includes('CIA')) {
                        updateGAForm(fieldName, [...value, 'CIA']);
                    } else {
                        // console.log(agent)
                        if (values.Genwizard_Core.some(v => ['AD', 'UTKM'].includes(v))) {
                            if (!value.includes('Config-Agent')) {
                                value.push('Config-Agent');
                            }
                        }
                        updateGAForm(fieldName, [...value]);
                    }
                }
            }
            if (fieldName === "Genwizard_Agent_Tool") {
                let tool = [...values.Genwizard_Agent_Tool];
                const GenTool = values.Genwizard_Tool;
                if (event.target.checked) {
                    if (!tool.includes(event.target.name))
                        tool.push(event.target.name);
                    if (event.target.name === 'ADO') {
                        GenTool[event.target.name] = {
                            'ProjectKey': '',
                            'Endpoint': '',
                            'Username': '',
                            'Password': '',
                            'PAT': '',
                        }
                    } else {
                        GenTool[event.target.name] = {
                            'ProjectKey': '',
                            'Endpoint': '',
                            'Username': '',
                            'Password': '',
                        }
                    }
                    updateGAForm("Genwizard_Tool", GenTool)
                } else {
                    tool = tool.filter(item => item !== event.target.name);
                    delete GenTool[event.target.name]
                    updateGAForm("Genwizard_Tool", GenTool)
                }
                updateGAForm(fieldName, [...tool]);
            }

            if (fieldName === 'Genwizard_Tool') {
                const GenTool = values.Genwizard_Tool;
                const toolName = event.target.id.split('_')
                GenTool[toolName[0]][toolName[1]] = value
                updateGAForm(fieldName, GenTool);
            }

            if (fieldName === "GDPR" && value === "yes") {
                updateGAForm("DeploymentRegion", "");
            }
            if (fieldName === "DeploymentRegion") {
                if (value == "sydney") {
                    setRegionCode("dh")
                } else if (value == "virginia") {
                    setRegionCode("dh1")
                } else if (value == "frankfurt") {
                    setRegionCode("dh2")
                } else if (value == "singapore") {
                    setRegionCode("dh3")
                } else if (value == "tokyo") {
                    setRegionCode("dh4")
                } else if (value == "ireland") {
                    setRegionCode("dh5")
                } else if (value == "london") {
                    setRegionCode("dh6")
                } else {
                    setRegionCode("[__]")
                }
            }
            if (fieldName === "DataClassification") {
                if (value === "Client-Production" || value === "Internal-Production") {
                    setEnv("Production")
                } else if (value === "Client-NonProduction") {
                    setEnv("Test")
                } else if (value === "AppTeam-Development") {
                    setEnv("Dev")
                    updateGAForm("Tier", "")
                } else if (value === "AppTeam-Testing") {
                    setEnv("Test")
                    updateGAForm("Tier", "")
                } else {
                    setEnv("")
                    updateGAForm("Tier", "")
                }
            }
        }
    };
    updateGAForm("ConfigurationType", configurationType);
    getSelectedEnvironment(env);
    updateGAForm("Environment", env);
    // it would check whether the root has existed from DB once user stop typing longer than 0.3s
    const debouncedValue = useDebounce(domainContextRoot, 300);
    useEffect(() => {
        debouncedValue && checkDomainAvaliable(debouncedValue);
    }, [debouncedValue]);

    //form validation
    const validateInputFields = (step) => {
        // If not final submit, allow navigation (no validation)
        if (step !== 'submit') {
            return true;
        }

        let ispass = true;
        const missingFields = [];

        // Final submit validation - validate ALL fields across all steps
        const allFieldsRequired = [
            // Step 0 fields
            'ProjectName',
            'WBSEcode',
            'SecondaryPOC',
            'DataClassification',
            'TeamName',
            'RequestNotes',
            // Step 1 fields
            'DeploymentRegion',
            'DomainContextRoot',
            'Environment',
            // Step 2 fields
            'AdminDistributionGroup',
            'TentativeServiceEndDate'
        ];

        // Add conditional required fields
        if (!config) {
            if (isChecked)
                allFieldsRequired.push('SAPContractID');
            else
                allFieldsRequired.push('Pocdetails', 'ClientName');

            // RITM is always mandatory, OpportunityID is optional
            allFieldsRequired.push('RITM');
        } else {
            // Quick config only requires RITM
            allFieldsRequired.push('RITM');
        }

        if (isOpenAI) {
            allFieldsRequired.push(
                'ChatGPT',
                'OpenAITextEmbeddingsModel'
            );
        }

        if (isDialogFlow) {
            allFieldsRequired.push('DialogFlowDevToken', 'DialogFlowClientToken');
        }

        if (values.Genwizard_Agent_Tool.includes('ADO')) {
            allFieldsRequired.push('ADO_ProjectKey', 'ADO_Endpoint', 'ADO_Username', 'ADO_Password', 'ADO_PAT')
        }
        if (values.Genwizard_Agent_Tool.includes('JIRA')) {
            allFieldsRequired.push('JIRA_ProjectKey', 'JIRA_Endpoint', 'JIRA_Username', 'JIRA_Password')
        }

        // Validate Genwizard Core selection
        const coreWrapper = document.getElementById('Genwizard_Core_wrapper');
        if (!values.Genwizard_Core || values.Genwizard_Core.length === 0) {
            if (coreWrapper) {
                coreWrapper.style.outline = "1px solid #E20000";
                coreWrapper.style.outlineOffset = "-1px";
                coreWrapper.style.borderRadius = "4px";
            }
            missingFields.push('Genwizard Core selection');
            ispass = false;
        } else {
            if (coreWrapper) coreWrapper.style.outline = "";
        }

        // Validate Agent selection when AD is selected
        const agentWrapper = document.getElementById('Genwizard_agent_wrapper');
        if (
            values.Genwizard_Core &&
            values.Genwizard_Core.includes('AD') &&
            (!values.Genwizard_Agent_Module.filter(item => item !== 'CIA') || values.Genwizard_Agent_Module.filter(item => item !== 'CIA').length === 0)
        ) {
            if (agentWrapper) {
                agentWrapper.style.outline = "1px solid #E20000";
                agentWrapper.style.outlineOffset = "-1px";
                agentWrapper.style.borderRadius = "4px";
            }
            missingFields.push('Agent Module selection (required when AD is selected)');
            ispass = false;
        } else {
            if (agentWrapper) agentWrapper.style.outline = "";
        }
        //remove for now
        // if (values.Genwizard_Agent_Module.includes('CIA') && values.modelname === "") {
        //     missingFields.push('Model Name is required');
        // }
        if (values.Genwizard_Core.includes('AM')) {
            missingFields.push('RITM');
        }

        // Check for missing fields (basic empty validation - red borders handled by hook)
        for (const fieldname of allFieldsRequired) {
            if (fieldname === "WBSEcode") {
                // WBSE validation: empty OR API validation failed
                if (!values[fieldname] || values[fieldname] === "" || !isWBSEValid) {
                    missingFields.push(fieldname);
                    ispass = false;
                }
            } else if (fieldname === "RITM") {
                if (!values.RITM || values.RITM === "" || values.RITM === null) {
                    missingFields.push(fieldname);
                    ispass = false;
                } else if (ritmAPIValidation === false) {
                    missingFields.push(`${fieldname} (not found in records)`);
                    ispass = false;
                } else if (!isRITMValid) {
                    missingFields.push(`${fieldname} (invalid format)`);
                    ispass = false;
                }
            } else if (fieldname === "OpportunityID") {
                // OpportunityID is optional, but if provided, it must be valid
                if (values.OpportunityID && values.OpportunityID !== "" && values.OpportunityID !== null) {
                    if (opportunityAPIValidation === false) {
                        missingFields.push(`${fieldname} (not found in records)`);
                        ispass = false;
                    } else if (!isOpportunityIDValid) {
                        missingFields.push(`${fieldname} (invalid format)`);
                        ispass = false;
                    }
                }
            } else if (fieldname === 'DialogFlowDevToken' || fieldname === 'DialogFlowClientToken') {
                if (values['DialogFlowDevToken'] === "" && values['DialogFlowClientToken'] === "") {
                    missingFields.push('DialogFlow Token (either Dev or Client token required)');
                    ispass = false;
                }
            } else if (fieldname === "TentativeServiceEndDate" && (!selectedEnvironment || selectedEnvironment === "")) {
                // TentativeServiceEndDate requires environment to be selected first
                missingFields.push(fieldname);
                ispass = false;

            } else if (fieldname.indexOf('ADO') >= 0) {
                const adoValue = values.Genwizard_Tool['ADO']
                if (adoValue[fieldname.replace('ADO_', '')] === '') {
                    missingFields.push(fieldname);
                    ispass = false;
                }
            }
            else if (fieldname.indexOf('JIRA') >= 0) {
                const adoValue = values.Genwizard_Tool['JIRA']
                if (adoValue[fieldname.replace('JIRA_', '')] === '') {
                    missingFields.push(fieldname);
                    ispass = false;
                }
            } else if (fieldname === "Pocdetails") {
                if (values['Pocdetails'] === "" || !isPocvalid && values['Pocdetails'] !== "") {
                    missingFields.push(fieldname);
                    ispass = false;
                }
            }
            else if (values[fieldname] === "" || values[fieldname] === undefined || values[fieldname] === null) {
                missingFields.push(fieldname);
                ispass = false;
            }
        }

        // Use the hook to handle validation results (red borders + dialog)
        handleValidationResult(ispass, missingFields, formClickSubmit);
        return ispass;
    }

    return (
        <>
            <GeneralForm
                isPlanInputValid={isPlanInputValid}
                FormId={15}
                validateInputFields={validateInputFields}
                ClientContractFields={

                    <div>
                        {!config ?
                            <TopRadioWrapper>
                                <ConfigurationFormLabel component="legend">
                                    Is a Contract ID available?
                                </ConfigurationFormLabel>


                                <StyledRadioGroup
                                    aria-label="contract-available"
                                    name="contract-available"
                                    value={isChecked ? "yes" : "no"}
                                    onChange={handleContractAvailabilityChange}
                                    row
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio color="primary" />}
                                        label="YES"
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio color="primary" />}
                                        label="NO"
                                    />
                                </StyledRadioGroup>
                            </TopRadioWrapper>
                            : ""}

                        {(!isChecked && !config) &&
                            <div style={{ fontSize: "small", color: "#0041F0" }}>
                                <em>
                                    To proceed with provisioning without a Contract ID, please provide the following mandatory details
                                </em>
                                <ul>
                                    <li>WBSE Code (used for chargeback if contract is not provided)</li>
                                    <li>Opportunity ID (for deal tracking and reference)</li>
                                    <li>Expected Contract Availability Date (must be within 42 days)</li>
                                    <li>Client Point of Contact (name and email for contract follow-up)</li>
                                </ul>
                            </div>
                        }
                        <div style={{ flexGrow: 1 }}>
                            <Grid
                                container
                                spacing={2}
                            >
                                {(!config && isChecked) ?
                                    <Grid item xs={4}>
                                        {PlatformFormField.SAPContractIDPlatformField(values, handleChange, externalClientError, isExternalClientLoading, sapContractCodeLength)}
                                    </Grid>
                                    : (!config && !isChecked) ?
                                        <Grid item xs={4}>
                                            {FormField.Pocvalid(handleChange, values, isPocvalid)}
                                        </Grid>
                                        : <></>
                                }

                                {(!config &&
                                    isChecked &&
                                    sapContractCodeLength === 10 &&
                                    !isExternalClientLoading &&
                                    !externalClientError) &&
                                    <Grid item xs={4}>
                                        {PlatformFormField.ClientNamePlatformField(
                                            values,
                                            handleChange,
                                            externalClientData[0]
                                        )}
                                    </Grid>
                                }
                                {!config &&
                                    isChecked &&
                                    sapContractCodeLength === 10 &&
                                    !isExternalClientLoading &&
                                    !externalClientError && (
                                        <Grid item xs={4}>
                                            {PlatformFormField.EndToEndUIdPlatformField(
                                                values,
                                                handleChange,
                                                externalClientData[1]
                                            )}
                                        </Grid>
                                    )
                                }
                                {(!config && !isChecked) &&
                                    <Grid item xs={4}>
                                        <StyledTooltip
                                            title={longTextEndDate}
                                            placement="left-start"
                                            noValidate
                                        >
                                            <DateTextFieldCommonComponentv2
                                                tentativeServiceEndDate={values.ContractAvailabilityDate}
                                                minDate={0}
                                                maxDate={createMaxDate(27)}
                                                handleChange={handleChange}
                                                idkey="ContractAvailabilityDate"
                                                label="Contract Availability Date"
                                            />
                                        </StyledTooltip>
                                    </Grid>
                                }
                                {(!config) &&
                                    <>
                                        <Grid item xs={4}>
                                            <FormField.RITMField
                                                values={values}
                                                handleChange={handleChange}
                                                isRITMValid={isRITMValid}
                                                apiValidation={ritmAPIValidation}
                                                setAPIValidation={setRITMAPIValidation}
                                                configurationType={configurationType}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormField.OpportunityIDField
                                                values={values}
                                                handleChange={handleChange}
                                                isOpportunityIDValid={isOpportunityIDValid}
                                                apiValidation={opportunityAPIValidation}
                                                setAPIValidation={setOpportunityAPIValidation}
                                                configurationType={configurationType}
                                            />
                                        </Grid>
                                    </>
                                }
                                {(!config && !isChecked) &&
                                    <Grid item xs={4}>
                                        {FormField.ClientNamePlatformInternal(handleChange, values)}
                                    </Grid >}
                                <Grid item xs={4}>
                                    {FormField.ProjectNameField(handleChange, values, isProjectNameValid)}
                                </Grid>

                                {/* <Grid item xs={4}>
                                    {FormField.WBSECodeField(handleChange, values, isWBSECodeValid, isWBSEValid, isLoading)}
                                </Grid > */}
                                {config &&
                                    <Grid item xs={8}>
                                        <FormField.RITMField
                                            values={values}
                                            handleChange={handleChange}
                                            isRITMValid={isRITMValid}
                                            apiValidation={ritmAPIValidation}
                                            setAPIValidation={setRITMAPIValidation}
                                            configurationType={configurationType}
                                        />
                                    </Grid>
                                }
                                <Grid item xs={4}>
                                    {FormField.WBSECodeField(handleChange, values, isWBSECodeValid, isWBSEValid, isLoading)}
                                </Grid >
                                <Grid item xs={4}>
                                    {FormField.SecondaryContact(handleChange, values, config)}
                                </Grid>
                                <Grid item xs={4}>
                                    {FormField.DataClassificationField(handleChange, values, configurationType)}
                                </Grid>
                                <Grid item xs={4}>
                                    {FormField.TeamNamesField(handleChange, values, isTeamNameSelected, 'na', configurationType, instanceType)}
                                </Grid >
                                {values.TeamName === "Others" &&
                                    <Grid item xs={4}>
                                        {FormField.TeamNameOthers(handleChange, values)}
                                    </Grid >
                                }
                                {
                                    (config &&
                                        <Grid item xs={4}>
                                            {FormField.ClientNamePlatformInternal(handleChange, values)}
                                        </Grid>
                                    )
                                }
                                {/* <Grid item xs={4}>
                {config &&
                  FormField.ClientNamePlatformInternal(handleChange, values)}
              </Grid > */}
                                <Grid item xs={12}>
                                    {PlatformFormField.RequestNotesPlatformField(
                                        values,
                                        handleChange,
                                        notesValidations
                                    )}
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                }
                EnvironmentFields={
                    <div>
                        <div style={{ flexGrow: 1 }}>
                            <Grid
                                container
                                spacing={2}
                            >
                                <Grid item xs={12}>
                                    {PlatformFormField.GDPRPlatformField(
                                        values,
                                        handleChange,
                                        isGDPR,
                                        classes,
                                        config,
                                        isChecked
                                    )}
                                </Grid>
                                <Grid item xs={3}>
                                    {PlatformFormField.agent_deploymentRegion(
                                        values,
                                        handleChange,
                                        isGDPR,
                                        isDedicated,
                                        isOpenAI,
                                        instanceType,
                                        values.TeamName,
                                        configurationType
                                    )}
                                </Grid>
                                <Grid item xs={6}>
                                    {!config ? PlatformFormField.DomainContextRootPlatformFieldClient(
                                        values,
                                        handleChangeRootSuggestions,
                                        // handleChangeRoot,
                                        isRootExist,
                                        rootExistedHint,
                                        rootWrongFormatHint,
                                        externalClientData,
                                        domainContextRoot,
                                        isLoading
                                    ) : PlatformFormField.DomainContextRootPlatformField(
                                        values,
                                        handleChangeRoot,
                                        isRootExist,
                                        rootExistedHint,
                                        isLoading
                                    )}
                                </Grid>
                                <Grid item xs={3}>
                                    {PlatformFormField.EnvironmentField(values, handleChange, env)}
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                }

                ApplicationFields={
                    <div style={{ flexGrow: 1 }}>
                        <Grid
                            container
                            spacing={2}
                        >
                            {/* <Grid item xs={4}>
                                {FormField.DialogFlowField(handleChange, values, isDialogFlow)}
                            </Grid> */}
                            <Grid item xs={6}>
                                {FormField.ChatGPTFieldGA(handleChange, values)}
                            </Grid>
                            <Grid item xs={6}>
                                {FormField.OpenAITextEmbeddingsModel(handleChange, values)}
                            </Grid>
                            {/* if user select enable in DialogFlow, it would show DialogFlowDevToken with default value */}
                            {isDialogFlow &&
                                <Grid item xs={6}>{FormField.DialogFlowDevTokenField(handleChange, values)}</Grid>}
                            {isDialogFlow &&
                                <Grid item xs={6}>{FormField.DialogFlowClientTokenField(handleChange, values)}</Grid>}
                            {/* <Grid item xs={6}>
                                {FormField.SuperAdminDistributionGroupFieldQpp(handleChange, values, errorSADGroup, isADSADUnique)}
                            </Grid> */}
                            <Grid item xs={6}>
                                {/* {FormField.AdminDistributionGroupFieldQpp(handleChange, values, errorADGroup, isADSADUnique)} */}
                                {FormField.AdminDistributionGroupField(handleChange, values)}
                            </Grid>
                            <Grid item xs={6}>
                                <StyledTooltip
                                    title={longTextEndDate}
                                    placement="left-start"
                                    noValidate
                                >
                                    <DateTextFieldCommonComponent
                                        tentativeServiceEndDate={values.TentativeServiceEndDate}
                                        selectedEnvironment={selectedEnvironment}
                                        isServiceEndDateInvalid={isServiceEndDateInvalid}
                                        minDate={minDate}
                                        maxDate={maxDate}
                                        handleChange={handleChange}
                                        style={{ paddingTop: "10px" }}
                                    />
                                </StyledTooltip>
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ fontSize: "1rem", color: '#5f47c9', fontWeight: '600' }}>
                                    <label>
                                        Core
                                    </label>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                {values.Genwizard_Core.includes("CUI") &&
                                    <p>CUI URL: <span style={{ color: " #0041F0" }}>https://cui-{domainContextRoot}.dev.genwizardai.com/</span></p>
                                }
                                {/* {values.Genwizard_Core.includes("IAM") &&
                                    <p>IM URL: <span style={{ color: " #0041F0" }}>&nbsp;https://iam-{domainContextRoot}.dev.genwizardai.com/</span></p>
                                } */}
                                {values.Genwizard_Core.includes("KM") &&
                                    <p>KM URL: <span style={{ color: " #0041F0" }}>https://qpp-{domainContextRoot}.dev.genwizardai.com/</span></p>
                                }
                                {values.Genwizard_Core.includes("AM") &&
                                    <p>Expected Custom AM UI URL: <span style={{ color: " #0041F0" }}>https://{domainContextRoot}.agentmanager.com/</span></p>
                                }
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ fontSize: "small", color: "#c20000" }}>
                                    <em>
                                        Please select at least one App Core. Some App Core components require others to be installed. CUI and IM are bundles.
                                    </em>
                                </div>
                            </Grid>
                            <Grid item xs={6} id="Genwizard_Core_wrapper">
                                <FormGroup style={{ marginTop: '7px', padding: '0px 5px' }}>
                                    <FormControlLabel
                                        style={{ width: '300px', position: 'relative' }}
                                        control={
                                            <Checkbox
                                                checked={values.Genwizard_Core.includes('CUI')}
                                                onChange={(e) => handleChange(e, "Genwizard_Core")}
                                                name="CUI"
                                            />
                                        }
                                        label={
                                            <>
                                                Conversational UI (CUI)
                                                <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>v1.0.1</em>
                                            </>
                                        }
                                    />
                                    {/* <FormControlLabel
                                        style={{ width: '300px', position: 'relative' }}
                                        control={
                                            <Checkbox
                                                checked={values.Genwizard_Core.includes('IAM')}
                                                onChange={(e) => handleChange(e, "Genwizard_Core")}
                                                name="IAM"
                                            />
                                        }
                                        label={
                                            <>
                                                Identity Manager (IM)
                                                <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>v1.0.1</em>
                                            </>
                                        }
                                    /> */}
                                    <FormControlLabel
                                        style={{ width: '300px', position: 'relative' }}
                                        control={
                                            <Checkbox
                                                checked={values.Genwizard_Core.includes('KM')}
                                                // disabled={(values.Genwizard_Core.includes("CUI") && values.Genwizard_Core.includes("IAM")) ? false : true}
                                                disabled={(values.Genwizard_Core.includes("CUI")) ? false : true}
                                                onChange={(e) => handleChange(e, "Genwizard_Core")}
                                                name="KM"
                                            />
                                        }
                                        label={
                                            <>
                                                Knowledge Manager (KM)
                                                <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>v2.8.2</em>
                                            </>
                                        }

                                    />
                                    <FormControlLabel
                                        style={{ width: '300px', position: 'relative' }}
                                        control={
                                            <Checkbox
                                                checked={values.Genwizard_Core.includes('ATR')}
                                                // disabled={(values.Genwizard_Core.includes("CUI") && values.Genwizard_Core.includes("IAM")) ? false : true}
                                                disabled={(values.Genwizard_Core.includes("CUI")) ? false : true}
                                                onChange={(e) => handleChange(e, "Genwizard_Core")}
                                                name="KM"
                                            />
                                        }
                                        label={
                                            <>
                                                ATR
                                                <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>v2.8.2</em>
                                            </>
                                        }

                                    />
                                    {(!config && !externalClientError) &&
                                        <FormControlLabel
                                            style={{ width: '300px', position: 'relative' }}
                                            control={
                                                <Checkbox
                                                    checked={values.Genwizard_Core.includes('AM')}
                                                    onChange={(e) => handleChange(e, "Genwizard_Core")}
                                                    name="AM"
                                                    disabled={(!config && !externalClientError) ? false : true}
                                                />
                                            }

                                            label={
                                                <>
                                                    Agent Manager (AM)
                                                    <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>v1.1.0</em>
                                                </>
                                            }
                                        />
                                    }
                                </FormGroup>
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ fontSize: "1rem", color: '#5f47c9', fontWeight: '600' }}>
                                    <label>
                                        Agent
                                    </label>
                                </div>
                            </Grid>
                            <Grid item xs={12}>

                                {values.Genwizard_Core.includes("AD") &&
                                    <>
                                        <p>AD UI URL: <span style={{ color: " #0041F0" }}>https://ad-{domainContextRoot}.dev.genwizardai.com/</span></p>
                                        <p>AD API URL: <span style={{ color: " #0041F0" }}>https://ad-api-{domainContextRoot}.dev.genwizardai.com/</span></p>
                                    </>
                                }
                                {values.Genwizard_Core.includes("UTKM") &&
                                    <>
                                        <p>Knowledge Transition URL: <span style={{ color: " #0041F0" }}>https://cui-{domainContextRoot}.dev.genwizardai.com/knowledgetransition</span></p>
                                        <p>Steward URL: <span style={{ color: " #0041F0" }}>https://cui-{domainContextRoot}.dev.genwizardai.com</span></p>
                                    </>
                                }
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ fontSize: "small", color: "#c20000" }}>
                                    <em>
                                        {/* Selecting AD or Steward requires CUI, KM, and IM / CIA requires AM. To choose a different app, uncheck AD / Steward / CIA. */}
                                        {/* Selecting AD or Steward requires CUI, KM, and IM. To choose a different app, uncheck AD / Steward. */}
                                        Agents are optional
                                    </em>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <FormGroup style={{ marginTop: '7px', padding: '0px 5px' }}>
                                    <FormControlLabel
                                        style={{ width: '400px', position: 'relative' }}
                                        control={
                                            <Checkbox
                                                checked={values.Genwizard_Core.includes('AD')}
                                                onChange={(e) => handleChange(e, "Genwizard_Core")}
                                                name="AD" />
                                        }
                                        label={
                                            <>
                                                Ticket Resolver Agent
                                                <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>v1.0.0</em>
                                            </>
                                        }
                                    />
                                    <FormControlLabel
                                        style={{ width: '400px', position: 'relative' }}
                                        control={
                                            <Checkbox
                                                checked={values.Genwizard_Core.includes('UTKM')}
                                                onChange={(e) => handleChange(e, "Genwizard_Core")}
                                                name="UTKM" />
                                        }
                                        label={
                                            <>
                                                Root Casuse Analyzer Agent
                                                <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>v1.0.0</em>
                                            </>
                                        }
                                    />
                                    <FormControlLabel
                                        style={{ width: '400px', position: 'relative' }}
                                        control={
                                            <Checkbox
                                                checked={values.Genwizard_Core.includes('UTKM')}
                                                onChange={(e) => handleChange(e, "Genwizard_Core")}
                                                name="UTKM" />
                                        }
                                        label={
                                            <>
                                                Infra Ops (Certificate Manager Agent)
                                                <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>v1.0.0</em>
                                            </>
                                        }
                                    />
                                </FormGroup>
                            </Grid>
                            {values.Genwizard_Core.includes('AD') &&
                                <Grid item xs={4} id="Genwizard_agent_wrapper">
                                    {FormField.GAAgents(handleChange, values, sortAssetsList, selectedAsset)}
                                </Grid>
                            }
                            {values.Genwizard_Agent_Module.includes('CIA') &&
                                <Grid item xs={4} id="Genwizard_agent_wrapper">
                                    {FormField.BedrockPlatformModel(values, handleChange, '')}
                                </Grid>
                            }
                            {values.Genwizard_Core.includes('AD') &&
                                <>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: "1rem", color: '#5f47c9', fontWeight: '600' }}>
                                            <label>
                                                Tool
                                            </label>
                                        </div>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <div style={{ fontSize: "small", color: "#c20000" }}>
                                            <em>
                                                This features only available on for AD Agent
                                            </em>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormGroup style={{ padding: '0px 5px' }}>
                                            <FormControlLabel
                                                style={{ width: '300px', position: 'relative' }}
                                                control={
                                                    <Checkbox
                                                        checked={values.Genwizard_Agent_Tool.includes('ADO')}
                                                        onChange={(e) => handleChange(e, "Genwizard_Agent_Tool")}
                                                        name="ADO" />
                                                }
                                                label="ADO"
                                            />
                                        </FormGroup>
                                    </Grid>
                                    {values.Genwizard_Agent_Tool.includes('ADO') &&
                                        <>
                                            <Grid item xs={3}>
                                                {FormField.GAToolProjectKey(handleChange, values, "ADO")}
                                            </Grid>
                                            <Grid item xs={3}>
                                                {FormField.GAToolEndPoint(handleChange, values, "ADO")}
                                            </Grid>

                                            <Grid item xs={3}>
                                                {FormField.GAToolUsername(handleChange, values, "ADO")}
                                            </Grid>
                                            <Grid item xs={3}>
                                                {FormField.GAToolPassword(handleChange, values, "ADO", ttpword, setTtpword)}
                                            </Grid>
                                            <Grid item xs={3}>
                                                {FormField.GAToolPAT(handleChange, values, "ADO")}
                                            </Grid>
                                        </>
                                    }
                                    <Grid item xs={12}>
                                        <FormGroup style={{ padding: '0px 5px' }}>
                                            <FormControlLabel
                                                style={{ width: '300px', position: 'relative' }}
                                                control={
                                                    <Checkbox
                                                        checked={values.Genwizard_Agent_Tool.includes('JIRA')}
                                                        onChange={(e) => handleChange(e, "Genwizard_Agent_Tool")}
                                                        name="JIRA" />
                                                }
                                                label="JIRA"
                                            />
                                        </FormGroup>
                                    </Grid>
                                    {values.Genwizard_Agent_Tool.includes('JIRA') &&
                                        <>
                                            <Grid item xs={3}>
                                                {FormField.GAToolProjectKey(handleChange, values, "JIRA")}
                                            </Grid>
                                            <Grid item xs={3}>
                                                {FormField.GAToolEndPoint(handleChange, values, "JIRA")}
                                            </Grid>

                                            <Grid item xs={3}>
                                                {FormField.GAToolUsername(handleChange, values, "JIRA")}
                                            </Grid>
                                            <Grid item xs={3}>
                                                {FormField.GAToolPassword(handleChange, values, "JIRA", ttpword, setTtpword)}
                                            </Grid>
                                        </>
                                    }
                                </>
                            }
                        </Grid>
                    </div>
                }
                LeftColumnFields={
                    <div>
                    </div>
                }
                RightColumnFields={
                    <div>
                    </div>
                }
                history={history}
                productname={'NoTouch'}
            ></GeneralForm>

            {/* Validation Error Dialog */}
            <ValidationDialog
                open={showValidationDialog}
                onClose={closeDialog}
                errors={validationErrors}
            />

            {!isChecked && (
                <CommonDialogV2
                    open={isNoteVisible}
                    onClose={() => setNoteVisible(false)}
                    title={"Note"}
                    textContent={
                        <div>
                            <div style={{ textAlign: 'center', fontSize: '1.1em', fontWeight: '500' }}>If a valid contract is not provided within the 4-week period</div>
                            <ul>
                                <li>
                                    Provisioned services will be automatically stopped
                                </li>
                                <li>
                                    Cost recovery will be initiated using the provided WBSE code
                                </li>
                            </ul>
                        </div>
                    }
                    dialogActions={
                        <DialogActions >
                            <AcceptButton2 onClick={() => setNoteVisible(false)} label={"Ok"} />
                        </DialogActions>
                    }
                ></CommonDialogV2>
            )}
        </>
    );
};

const MSTP = (state, ownProps) => ({
    values: state.fui.GAForm,
    isRootExist: state.fui.isRootExist,
    isWBSEValid: state.fui.isWBSEValid,
    configurationType: state.fui.configurationType,
    email: state.auth.userDetails.email,
    idToken: state.auth.idToken,
    externalClientData: state.fui.externalClientData,
    externalClientError: state.fui.externalClientError,
    isExternalClientLoading: state.fui.isExternalClientLoading,
    isLoading: state.fui.isLoading,
});

export default connect(MSTP, {
    checkDomainAvaliable: checkRootExisted,
    updateGAForm: fuiRedux.updateGAForm,
    fetchExternalClientDetails,
    checkIsWBSEValid
})(withRouter(NoTouch));
